const moment = require('moment');

// Current (2025-26) SAT CSV crosswalk: detect by the Reading-and-Writing + Math section headers.
const isCurrentCSVHeader = (line) => {
  const headers = line.split(',').map((h) =>
    h
      .trim()
      .toLowerCase()
      .replace(/^"|"$/g, '')
  );
  const hasReadingWriting = headers.some(
    (h) =>
      h === 'reading and writing section score' ||
      h === 'rw section score' ||
      h === 'reading and writing section' ||
      h === 'latest sat reading and writing section'
  );
  const hasMath = headers.some(
    (h) => h === 'math section score' || h === 'math section' || h === 'latest sat math section'
  );
  return hasReadingWriting && hasMath;
};

const validateFile = (text, type) =>
  new Promise((resolve) => {
    const lines = text.split(/\r\n?|\n/);
    if (type === 'application/vnd.ms-excel' || type === 'text/csv') {
      const legacyLookingFor = /,LATEST_SAT_TOTAL,/;
      for (let i = 0; i < lines.length; i += 1) {
        const line = lines[i];
        if (line && (legacyLookingFor.exec(line) || isCurrentCSVHeader(line))) {
          resolve(true);
          return;
        }
      }
      resolve(false);
      return;
    }
    if (type === 'text/plain') {
      for (let i = 0; i < lines.length; i += 1) {
        const line = lines[i];
        if (line) {
          // Current fixed-width: 1435 chars/line, birth date YYYY-MM-DD at positions 196-205.
          if (line.length === 1435) {
            const birthDate = line.slice(195, 205);
            if (!(birthDate && moment(birthDate, 'YYYY-MM-DD', true).isValid())) {
              resolve(false);
              return;
            }
            // eslint-disable-next-line no-continue
            continue;
          }
          // Legacy fixed-width: 2661 chars/line, birth date YYYY-MM-DD at positions 203-212.
          if (line.length !== 2661) {
            resolve(false);
            return;
          }
          const birthDate = line.slice(202, 212);
          // const readingScore = Number(line.slice(676, 678));
          // const mathScore = Number(line.slice(679, 682));
          if (!(birthDate && moment(birthDate, 'YYYY-MM-DD', true).isValid())) {
            resolve(false);
            return;
          }
        }
      }
      resolve(true);
    }
  });

const isSAT2019 = (file) =>
  new Promise((resolve) => {
    if (file.type !== 'application/vnd.ms-excel' && file.type !== 'text/csv' && file.type != 'text/plain') {
      resolve(false);
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      const isValidated = await validateFile(reader.result, file.type);
      resolve(isValidated);
    };
    reader.readAsText(file);
  });

export default isSAT2019;
